export function addWatermarkToPhoto(base64Image: string): Promise<string> {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = base64Image;
        
        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                reject('Canvas context not available');
                return;
            }

            // Установка размеров canvas равными размерам изображения
            canvas.width = img.width;
            canvas.height = img.height;

            // Отрисовка изображения
            ctx.drawImage(img, 0, 0);

            // Настройка стиля текста
            const fontSize = Math.max(20, img.width * 0.03);
            ctx.font = `${fontSize}px Arial`;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            
            // Поворот текста
            ctx.save();
            ctx.translate(canvas.width/2, canvas.height/2);
            ctx.rotate(-Math.PI/4);
            
            // Добавление текста с большим расстоянием между строками
            const text = 'ЗАПРЕЩЕНО КОПИРОВАТЬ И ИСПОЛЬЗОВАТЬ ОТДЕЛЬНО ОТ ДАННОГО ДОКУМЕНТА';
            const repeats = Math.ceil(Math.max(canvas.width, canvas.height) / 400);
            
            for(let i = -repeats; i <= repeats; i++) {
                // Добавляем обводку
                ctx.strokeStyle = 'rgba(0, 0, 0, 0.15)';
                ctx.lineWidth = fontSize / 8;  // Толщина обводки пропорциональна размеру шрифта
                ctx.strokeText(text, 0, i * 150);
                
                // Добавляем сам текст
                ctx.fillStyle = 'rgba(255, 255, 255, 0.1)';
                ctx.fillText(text, 0, i * 150);
            }

            ctx.restore();

            resolve(canvas.toDataURL('image/jpeg', 0.9));
        };

        img.onerror = () => {
            reject('Failed to load image');
        };
    });
} 